import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import Timefield from '@/components/layout/timefield/Timefield.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import { mapState } from 'vuex'

export default {
  name: 'eventos',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    Datefield,
    Timefield,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina'])
  },

  data: () => {
    return {
      filtrosPesquisa: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      camposFiltroPesquisa: {
        nomeEvento: null,
        dataInicio: null,
        horaInicio: '',
        dataTermino: null,
        horaTermino: ''
      },
      componenteOrdenacao: {
        campo: 'f_dtstart',
        sentido: 'asc'
      },
      dadosRetorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      items: [],
      fields: [
        { key: 'f_summary', sortable: true, label: 'Evento' },
        { key: 'f_dtstart',
          sortable: true,
          label: 'Início',
          formatter: (value) => {
            return util.formatarData(value, 'DD/MM/YYYY HH:mm')
          }
        },
        { key: 'f_dtend',
          sortable: true,
          label: 'Término',
          formatter: (value) => {
            return util.formatarData(value, 'DD/MM/YYYY HH:mm')
          }
        },
        { key: 'f_location', sortable: true, label: 'Local' }
      ],
      listaDeEventos: []
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaEventosComoFiltroInicialADataAtual()
  },

  methods: {
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    obterListaEventosComoFiltroInicialADataAtual () {
      this.camposFiltroPesquisa.dataInicio = util.formatarData(new Date(), 'YYYY-MM-DD')
      this.filtrosPesquisa = {
        'f_dtstart': this.camposFiltroPesquisa.dataInicio
      }
      this.obterListaEventos()
    },

    async obterListaEventos () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': this.filtrosPesquisa,
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post('/agenda/eventos', parametrosRequisicao)
        this.listaDeEventos = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'

        this.obterListaEventos()
      }
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaEventos()
    },

    buscarRegistros () {
      this.resetarListaDeErros()

      if (this.verificarCamposDataEHoraEmBranco()) {
        return
      }

      this.filtrosPesquisa = {
        'f_summary': this.camposFiltroPesquisa.nomeEvento,
        'f_dtstart': util.formatarData(this.obterDataEHoraInicio(), 'YYYY-MM-DD HH:mm'),
        'f_dtend': util.formatarData(this.obterDataEHoraTermino(), 'YYYY-MM-DD HH:mm'),
        'f_status': this.camposFiltroPesquisa.status
      }
      this.componentePaginacao.pagina = 1
      this.obterListaEventos()
    },

    verificarCamposDataEHoraEmBranco () {
      let dataInicio = this.camposFiltroPesquisa.dataInicio
      let dataTermino = this.camposFiltroPesquisa.dataTermino
      let horaInicio = this.camposFiltroPesquisa.horaInicio
      let horaTermino = this.camposFiltroPesquisa.horaTermino

      let informarDataInicio = false
      if (util.ehValidoFormatoHora(horaInicio) && !util.ehValidoFormatoData(dataInicio)) {
        this.dadosRetorno.listaDeErros.dataInicio = mensagens.preencherCampoData
        informarDataInicio = true
      }

      let informarDataTermino = false
      if (util.ehValidoFormatoHora(horaTermino) && !util.ehValidoFormatoData(dataTermino)) {
        this.dadosRetorno.listaDeErros.dataTermino = mensagens.preencherCampoData
        informarDataTermino = true
      }

      if ((informarDataInicio || informarDataTermino)) {
        return true
      } else {
        return false
      }
    },

    obterDataEHoraInicio () {
      let dataDeInicio = util.valorVazio(this.camposFiltroPesquisa.dataInicio) ? this.camposFiltroPesquisa.dataInicio : this.camposFiltroPesquisa.dataInicio.concat(' ').concat(this.camposFiltroPesquisa.horaInicio)
      return dataDeInicio
    },

    obterDataEHoraTermino () {
      let dataDeTermino = util.valorVazio(this.camposFiltroPesquisa.dataTermino) ? this.camposFiltroPesquisa.dataTermino : this.camposFiltroPesquisa.dataTermino.concat(' ').concat(this.camposFiltroPesquisa.horaTermino)
      return dataDeTermino
    },

    incluirEvento () {
      this.$router.push({ name: 'cadastro-eventos' })
    },

    editarEvento (id) {
      this.$router.push({ name: 'edicao-eventos', params: { id: id } })
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    resetarListaDeErros () {
      this.dadosRetorno.sucesso = false
      this.dadosRetorno.mensagem = ''
      this.dadosRetorno.listaDeErros = []
    },

    voltarCalendario () {
      this.$router.push({ name: 'agenda' })
    },

    redirecionarParaListagemConvites () {
      this.$router.push({ name: 'listagem-convites' })
    }
  }
}
